module.exports = __webpack_public_path__ + "static/paaolmsventurestudioUI-UX-b68e4f243b5456b0c74726c137a2e788.mp4";